import React from 'react';
import AMPScript from 'components/AMPScript';
import { euCountryCodes, pclnPrivacyPolicyLink } from 'constants/';
import Icon from 'components/Icon';
import BaseLink from 'components/Link/BaseLink';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const BannerContainer = styled.div`
    background-color: ${themeGet('colors.lightBlue')};
    padding: ${themeGet('space.4')}px;
    color: ${themeGet('colors.darkBlue')};
    display: inline-flex;
    position: fixed;
    z-index: 999;
    bottom: 0;
    button {
        background-color: ${themeGet('colors.lightBlue')};
        color: ${themeGet('colors.darkBlue')};
        border: none;
        cursor: pointer;
    }
`;

export const BannerDesc = styled.div`
    padding-left: ${themeGet('space.2')}px;
    padding-right: ${themeGet('space.4')}px;
`;

const AMPCookieBanner = () => {
    return (
        <div>
            <AMPScript tag="amp-geo" />
            <AMPScript tag="amp-user-notification" />
            <AMPScript tag="amp-analytics" />
            <amp-geo layout="nodisplay">
                <script
                    type="application/json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            ISOCountryGroups: {
                                eu: euCountryCodes
                            }
                        })
                    }}
                />
            </amp-geo>
            <amp-user-notification id="cookie-notification" layout="nodisplay" data-show-if-geo="eu">
                <BannerContainer>
                    <Icon name="information" />
                    <BannerDesc>
                        We use cookies for technical, analytical and marketing purposes.{' '}
                        <BaseLink href={pclnPrivacyPolicyLink} target="_blank" rel="noopener noreferrer">
                            Here is more information.
                        </BaseLink>{' '}
                        Please proceed if this is okay with you.
                    </BannerDesc>
                    <button type="button" on="tap:cookie-notification.dismiss" className="ampstart-btn caps ml1">
                        <Icon name="close" />
                    </button>
                </BannerContainer>
            </amp-user-notification>
        </div>
    );
};

export default AMPCookieBanner;
